import React from 'react';
import styled from 'styled-components';

const HeaderPlaceholderContainer = styled.div`
  border-bottom: 1px solid #ecf1f3;
  position: relative;

  ::after {
    background: linear-gradient(rgba(0, 0, 0, 0.03), transparent);
    bottom: -6px;
    content: '';
    height: 6px;
    position: absolute;
    width: 100%;
  }
`;

const HeaderBar = styled.div`
  background-color: #242934;
  height: 48px;
`;

const LogoBar = styled.div`
  height: 78px;
`;

export const HeaderPlaceholder = () => (
  <HeaderPlaceholderContainer>
    <HeaderBar />
    <LogoBar />
  </HeaderPlaceholderContainer>
);
